<template lang="pug">
.bg-grey.w-full.p-40
  .max-w-718
    BriqPanel.briq-panel
      iframe.pt-M(:srcdoc="mailBody" onload="this.style.height=(this.contentWindow.document.body.scrollHeight+20)+'px';" frameBorder="0")
</template>

<script>
import { mapGetters } from 'vuex'
import { find, propEq } from 'ramda'

export default {
  name: 'ViewMail',
  props: {
    mailKey: String,
  },
  computed: {
    ...mapGetters('bookingDetails', ['mails']),
    mailBody() {
      const mail = find(propEq('Key', this.mailKey))(this.mails)
      return mail.Body
    },
  },
}
</script>

<style scoped lang="stylus">
.briq-panel
  width 90%
iframe
  width 100%
  height 100%
</style>
